<template>
    <v-container>
        <h1>الملف الشخصي</h1>

        <v-row>
            <v-col md="6" cols="12">

                <v-row>
                    <v-col md="6" cols="6">الاسم:</v-col>
                    <v-col md="6" cols="6">{{user.name}}</v-col>
                </v-row>

                <v-row>
                    <v-col md="6" cols="6">الايميل:</v-col>
                    <v-col md="6" cols="6">{{user.email}}</v-col>
                </v-row>

            </v-col>
            
        </v-row>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'Profile',
    computed: {
      ...mapGetters(['loading', 'user'])
    },
}
</script>